<div>
  <div class="notification__image-wrapper">
    <pp-icon
      class="notification__image"
      [ppSVG]="iconMap[EIconPath.ICON_RELATED_LINK]"
      ppColor="primary-950"
    />
  </div>

  <span>
    @switch (ppNotification().metadata?.action) {
      @case (ERelatedPointAction.ADDED) {
        <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
      }
      @case (ERelatedPointAction.REMOVED) {
        <span class="notification__blue-text">{{ 'removed' | ppTranslate }}</span>
      }
    }
    {{ 'notification_relationship_description' | ppTranslate }}
  </span>
</div>

<div class="notificationRelationship__pointBlock">
  <div class="notification__point notificationRelationship__pointTitle">
    {{ ppNotification().refObject?.sequenceNumber }} - {{ ppNotification().refObject?.name }}
  </div>
  <div class="notificationRelationship__site">
    <span class="notification__site">{{ ppNotification().accountName }}</span>
    <pp-icon
      class="notification__footer-arrow"
      [ppSVG]="iconMap[EIconPath.ICON_MISC_RIGHT_ARROW_14]"
      ppColor="grey-400"
    />
    <span class="notification__site">{{ ppNotification().siteName }}</span>
  </div>
</div>

<div class="notificationRelationship__to">{{ 'to' | ppTranslate }}</div>

<div class="notificationRelationship__pointBlock">
  <div class="notification__point notificationRelationship__pointTitle">
    {{ ppNotification().metadata?.relatedPointSequenceNumber }} -
    {{ ppNotification().metadata?.relatedPointTitle }}
  </div>
  <div class="notificationRelationship__site">
    <span class="notification__site">{{
      ppNotification().metadata?.relatedPointAccountName || ppNotification().accountName
    }}</span>
    <pp-icon
      class="notification__footer-arrow"
      [ppSVG]="iconMap[EIconPath.ICON_MISC_RIGHT_ARROW_14]"
      ppColor="grey-400"
    />
    <span class="notification__site">{{
      ppNotification().metadata?.relatedPointSiteName || ppNotification().siteName
    }}</span>
  </div>
</div>
